import { BaseButton, SECONDARY } from "components/buttons/BaseButton";
import VerifiedUserIcon from "../UI/VerifiedUserIcon";
import { useNavigate } from "react-router-dom";
import { routes } from "routes";

interface IVerifiedButtonProps {
  onClick?: () => void;
}

export const VerifiedButton = ({ onClick }: IVerifiedButtonProps) => {
  const navigate = useNavigate();

  const handleToVerify = () => {
    navigate(routes.verify());

    if (onClick) {
      onClick();
    }
  };

  return (
    <BaseButton variant={SECONDARY} onClick={handleToVerify} aria-label="Get Verified" type="button">
      <VerifiedUserIcon />
      Get Verified
    </BaseButton>
  );
};
